import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'studio-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<div class="studio-shell"><router-outlet></router-outlet></div>`
})
export class AppComponent implements OnInit {
  constructor(private language: LanguageService) {}
  ngOnInit(): void {
    this.language.applyDirection();
  }
}
